
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Experience the best river cruises in Goa with beautiful views, live entertainment, and delicious food aboard comfortable boats.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover Goa’s top river cruises, offering stunning river views, great dining, and a peaceful experience. Perfect for outings with friends or family.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy a relaxing Goa river cruise with scenic views, tasty food, and live music. A great choice for a special day out with loved ones.',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'cruise ship packages in goa, goa cruise ship package, cruise ship packages, cruise ship packages price, romantic dinner cruise in goa, swastik dinner cruise in goa, luxury dinner cruise in goa',
        },

      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'Cruise Ship Packages in Goa - Cruise Ship Packages Price',
    };
  },


 jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/cruise-ship-packages-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/cruise-ship-packages-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/cruise-ship-packages-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Cruise Ship Packages in Goa - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Dinner Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/cruise-ship-packages-goa",
        "url": "https://www.goa.app/cruise-ship-packages-goa",
        "name": "Cruise Ship Packages in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-05T10%3A30%3A44.908ZKaze1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=WbX7F8szd2lj%2FqRvmJ%2B832IFSDrAx9R9uif44xJY53LQjsPXxU2nICh1qh%2FIUh6xUw3s2%2Bsf1X%2BmXQCHsZ%2BG0y3S%2Fb9pElLlUJJqWBMbIPz%2Bttj6X2PqshLgJEQ7UINguJayWWHl82U1hbocw7v2jvUV9mt7Zbgwd88%2FafZqYuXKSyX6ShC4nSxXt4LZFqR4HRtFmYLdOdk1jIiHs3OMhe67N4yvhbgCJGtgk%2BmkpOAfx2Ck6UJq4o%2FyfWIpsJRHdJ%2FNBSwAxKcm8Zrlo0PcTi%2FCL7WHsx6JlvFz8RwPLzhVhv3cVFvSnku06sEEqeUxstwIw%2B02c7SYeOGtPMpl4A%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Cruise Ship Packages in Goa offers a memorable experience with scenic views, lively entertainment, and great vibes. Ideal for celebrations or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while partying along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/cruise-ship-packages-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/cruise-ship-packages-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a Cruise Ship Package in Goa through various online platforms or by contacting local operators. Booking in advance, especially during peak season, is recommended to secure your spot."
  }
},
{
  "@type": "Question",
  "name": "What is included in a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Cruise Ship Packages in Goa typically include the cruise, crew, and basic amenities. Some packages offer extras like meals, beverages, and entertainment on board."
  }
},
{
  "@type": "Question",
  "name": "What should I wear for a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It’s recommended to wear comfortable, smart casual attire. Dress for the weather and don't forget your swimwear if you plan to take a dip or engage in water activities."
  }
},
{
  "@type": "Question",
  "name": "How long can I enjoy a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Cruise Ship Packages in Goa can last anywhere from a couple of hours to a full night, depending on the package. Longer cruises for special occasions can often be arranged."
  }
},
{
  "@type": "Question",
  "name": "Can I customize the experience on a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators allow customization for special occasions such as birthdays or anniversaries. You can add elements like decorations, meals, and entertainment."
  }
},
{
  "@type": "Question",
  "name": "Are meals and drinks included in the Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Cruise Ship Packages in Goa include meals and drinks, while others may offer them as an optional add-on. It's best to confirm with the cruise provider when booking."
  }
},
{
  "@type": "Question",
  "name": "What is the price range for Cruise Ship Packages in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Prices for Cruise Ship Packages in Goa typically start from ₹500 and can go up depending on the duration, inclusions, and amenities offered."
  }
},
{
  "@type": "Question",
  "name": "Can I book a Cruise Ship Package in Goa for a special occasion?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, Cruise Ship Packages in Goa are perfect for special occasions like anniversaries or celebrations. Many operators offer tailor-made packages for such events."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to book a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time to book a Cruise Ship Package in Goa is between November and February when the weather is pleasant. However, cruises are available year-round for a memorable experience."
  }
},
{
  "@type": "Question",
  "name": "Can I bring my own food and drinks on a Cruise Ship Package in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Cruise Ship Package operators allow you to bring your own food and beverages, while others provide catering services. It's advisable to check with the provider in advance."
  }
},
{
  "@type": "Question",
  "name": "Are Cruise Ship Packages in Goa suitable for water sports?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many Cruise Ship Packages in Goa offer additional water sports activities such as jet skiing and fishing. You can inquire about these options when booking your cruise."
  }
}

        ]
      }
    ]
  };
},

};



  